export const pdfLinks = [
  {
    label: "Purple Team Security Test",
    desc: "Simulated collaborative attacks to measure resilience.",
    bullets: [
      {
        label: "For",
        desc: "Enterprises preparing for red+blue team engagements",
      },
      {
        label: "Outcome",
        desc: "Joint threat visibility and mitigation plan",
      },
    ],
    src: "/securityTesting/Purple-Team-Security-Test-Datasheet-oms.pdf",
  },
  {
    label: "Red Team Testing",
    desc: "Ethical hacking to identify exploitable vulnerabilities.",
    bullets: [
      {
        label: "For",
        desc: "Mature orgs with existing security controls",
      },
      {
        label: "Outcome",
        desc: "Real-world attack simulation insights",
      },
    ],
    src: "/securityTesting/Red-Team-Testing-Datasheet.pdf",
  },
  {
    label: "Vulnerability Assessment",
    desc: "Systematic discovery of known weaknesses.",
    bullets: [
      {
        label: "For",
        desc: "SMBs and enterprises",
      },
      {
        label: "Outcome",
        desc: "Patch-level visibility with prioritization",
      },
    ],
    src: "/securityTesting/Vulnerability-Assessment-Datasheet-oms.pdf",
  },
  {
    label: "Wireless Assessment",
    desc: "Testing wireless network integrity and encryption.",
    bullets: [
      {
        label: "For",
        desc: "All businesses with internal Wi-Fi access",
      },
      {
        label: "Outcome",
        desc: "Protection of wireless access vectors",
      },
    ],
    src: "/securityTesting/Wireless-Assessment-Security-Test-Datasheet-oms.pdf",
  },
  {
    label: "Social Engineering Assessment",
    desc: "Simulated phishing and manipulation testing.",
    bullets: [
      {
        label: "For",
        desc: "Organizations concerned with human-factor risk",
      },
      {
        label: "Outcome",
        desc: "User awareness score and improvement plan",
      },
    ],
    src: "/securityTesting/Social-Engineering-Datasheet-oms.pdf",
  },
  {
    label: "Security Assessment Brief",
    desc: "High-level summary of posture and roadmap suggestions.",
    bullets: [
      {
        label: "For",
        desc: "Leadership review, audits",
      },
      {
        label: "Outcome",
        desc: "Executive-ready reporting",
      },
    ],
    src: "/securityTesting/Security-Assessment-Brief.pdf",
  },
];
